<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-5 row-cols-lg-5 row-cols-xl-5">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheInputText title="Tên bến xe" placeholder="Tìm theo tên" v-model="modelSearch.ten"
                                :isRequire=false @onChange="v => handlePageChange(1)" />
                        </div>
                        
                        <div class="col mb-3">
                            <TheSelect title="Hiển thị trên cổng" :options="category_ENABLED"
                                :initialValue="modelSearch.enabled" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false"
                                @onChange="(e) => { modelSearch.enabled = e; handlePageChange(1) }" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                        <b v-if="currentSearchType == typeDataList.CURRENT_LIST.id">{{ $t('labels.currentList') }}</b>
                        <b v-if="currentSearchType == typeDataList.DELETED_LIST.id">{{ $t('labels.deletedList') }}</b>
                    </h3>
                    <div class="card-tools">
                        <TheOpenMapButton :onClickParent="getMapInfoBenXe"></TheOpenMapButton>
                        <TheSwapButton v-model="currentSearchType" @button-clicked="handlePageChange(1)" />
                        <button type="button" class="btn btn-tool" data-toggle="dropdown" :title="$t('labels.cogs')">
                            <i class="fas fa-cogs"></i>
                            <div class="input-group-prepend">
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                        v-model="navigateCode.RESTORE" :onClick="confirmList"
                                        :submitArgs=[navigateCode.RESTORE] :isDivider="true">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.DELETE_TEMP" :onClick="confirmList"
                                        :submitArgs=[navigateCode.DELETE_TEMP] :isDivider="true">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                        v-model="navigateCode.DELETE" :onClick="confirmList"
                                        :submitArgs=[navigateCode.DELETE] :isDivider="true">
                                    </TheButtonInDropdown>

                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.ON_ENABLED" :onClick="confirmList"
                                        :submitArgs=[navigateCode.ON_ENABLED] :isDivider="false">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.OFF_ENABLED" :onClick="confirmList"
                                        :submitArgs=[navigateCode.OFF_ENABLED] :isDivider="true">
                                    </TheButtonInDropdown>
                                </div>
                            </div>
                        </button>
                        <TheCreateButton :onClickParent="() => { detail(null, 'create') }" />
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th style="width:5%">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                                    @click="selectAllRows($event)">
                                                <label for="checkboxAll" class="custom-control-label"></label>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="cursor" style="width:5%" @click="handleSortChange('benXeId')" title="Sắp xếp theo ID">
                                        ID
                                        <span v-if="sortBy == 'benXeId'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-2 cursor" style="min-width: 100px;" @click="handleSortChange('ten')" title="Sắp xếp theo tên">
                                        Tên bến xe
                                        <span v-if="sortBy == 'ten'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>


                                    <th class="col-4" style="min-width: 200px;">Địa chỉ</th>
                                    <th class="col-1">Số điện thoại</th>
                                    <th class="cursor" style="width:5%" @click="handleSortChange('stt')">
                                        STT
                                        <span v-if="sortBy == 'stt'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1">Hiển thị trên cổng</th>
                                    <th class="col-1 sticky-action">Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td @click="selectRow(item.benXeId)" style="cursor: pointer;"
                                        :title="$t('labels.selectItem')">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span v-if="(csList_Navigate.csList.includes(item.benXeId))" class="text-primary">&check;</span>
                                            <span v-else>&nbsp;</span>
                                        </div>
                                    </td>
                                    <td>{{ item.benXeId }}</td>
                                    <td>{{ item.ten }}</td>
                                    <td>{{ item.diaChi }}</td>
                                    <td>{{ item.sdt }}</td>
                                    <td>{{ item.stt }}</td>
                                    <td>
                                        <TheSwitchInTable 
                                        :placeholder="'Thay đổi hiển thị trên cổng '"
                                        v-model:initialValue="item.enabled" 
                                        :isReadOnly="currentSearchType == typeDataList.DELETED_LIST.id"
                                        :onChange="(e) => { navigateEnabledChange(item.benXeId, e.target.checked) }"
                                        ></TheSwitchInTable>
                                    </td>
                                    <td class="sticky-action">
                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                            v-model="tableButton.VIEWDETAILMAP" 
                                            :onClick="getMapInfoBenXe"
                                            :submitArgs="[item.benXeId]"
                                            :useChildMethos="true">
                                        </TheButtonInTable>
                                        <TheButtonInTable
                                            v-model="tableButton.VIEWDETAIL" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DETAIL]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                            v-model="tableButton.EDIT" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.UPDATE]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                            v-model="tableButton.DELETE" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DELETE_TEMP]">
                                        </TheButtonInTable>
                                        
                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                            v-model="tableButton.DELETE_REAL" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DELETE]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                            v-model="tableButton.RESTORE" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.RESTORE]">
                                        </TheButtonInTable>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


        </div>
    </section>

    <TheCRUDFrameModal ref="modalCRUDRef" idModal="crudModal" dialogClass=" modal-lg" :headerTitle="title"
        :displaySubmit="loadingSubmit" :onSubmit="handleSubmit" :titleSubmit="title" :styleButton="styleButton"
        v-model:showModalFlag="isShowModal.CRUDModal">
        <div class="row">
            <div class="col-md-6">
                <TheInputText title="Tên bến xe" placeholder="Nhập tên bến xe" :initialValue="model.ten" v-model="model.ten"
                    :error="errors.ten" :isReadOnly="isReadOnly" :isRequire=true :isMultipleLine="false"
                    :key="tempKey" />
            </div>          
            <div class="col-md-3">
                <TheInputText title="SĐT" placeholder="Nhập SĐT" :initialValue="model.sdt"
                    v-model="model.sdt" :error="errors.sdt" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-3">
                <TheInputText title="Website" placeholder="Nhập web" :initialValue="model.web"
                    v-model="model.web" :error="errors.web" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <TheInputText title="GPS Long" placeholder="Nhập GPS Long" :initialValue="model.gpsLong"
                    v-model="model.gpsLong" :error="errors.gpsLong" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-4">
                <TheInputText title="GPS Lat" placeholder="Nhập GPS Lat" :initialValue="model.gpsLat"
                    v-model="model.gpsLat" :error="errors.gpsLat" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-4">
                <TheGetLocationButton v-model:modelValueLat="model.gpsLat"
                    v-model:modelValueLong="model.gpsLong" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <TheInputText title="Địa chỉ" placeholder="Nhập địa chỉ" :initialValue="model.diaChi"
                    v-model="model.diaChi" :error="errors.diaChi" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <TheInputText title="Nhà xe" placeholder="Nhập nhà xe" :initialValue="model.nhaXe"
                    v-model="model.nhaXe" :error="errors.nhaXe" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="true" :isSummerNote="true" :key="tempKey" />
            </div>    
        </div>
        <div class="row">
            <div class="col-md-12">
                <TheInputText title="Tuyến đường" placeholder="Nhập tuyến đường"
                    :initialValue="model.tuyenDuong" v-model="model.tuyenDuong" :error="errors.tuyenDuong"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="true" :isSummerNote="true"
                    :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <TheInputText title="Ghi chú" placeholder="Nhập ghi chú" :initialValue="model.ghiChu"
                    v-model="model.ghiChu" :error="errors.ghiChu" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="true" :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <TheInputText title="STT" placeholder="Nhập STT" :initialValue="model.stt" v-model="model.stt"
                    :error="errors.stt" :isReadOnly="isReadOnly" :isRequire=true :isMultipleLine="false"
                    :key="tempKey" />
            </div>
            <div class="col-md-6">
                <TheSwitchButton  title="Hiển thị trên cổng" placeholder="Chọn hiển thị trên cổng" :isReadOnly="isReadOnly" :isRequire=false :key="tempKey" :error="''" v-model:initialValue="model.enabled"> </TheSwitchButton>
            </div>
        </div>
        <div class="row">
            <TheImageListPicker ref="filePicker" title="&nbsp;&nbsp;File hình ảnh" :initialValue="filesUpload"
                error="" :isReadOnly="isReadOnly" :isRequire="false" :isMultiple="false"
                @onChange="({ files, addedFiles, deletedFiles }) => { filesUpload = files }"
                :acceptFile="acceptImageType" :key="tempKey" />
        </div>
    </TheCRUDFrameModal>

            <TheDetailFrameModal ref="modalDetailRef" idModal="detailModal" dialogClass=" modal-lg"
                :headerTitle="modelRec.ten" v-model:showModalFlag="isShowModal.detailModal">
                <div class="row" v-if="modelRec && modelRec.hinhAnh">
                    <div class="container mt-3 mb-3 p-1 d-flex justify-content-center">
                        <div class=" image d-flex flex-column justify-content-center align-items-center">
                            <img :src="modelRec.linkHinhAnh" height="150" />
                        </div>
                    </div>
                </div>
                <div class="row" v-if="modelRec">
                    <div class="col-6 col-md-12 col-lg-6 order-1 order-md-2">
                        <p class="text-sm">ID:
                            <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.benXeId }}&nbsp;</b>
                        </p>
                        <p class="text-sm">STT:
                            <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.stt }}&nbsp;</b>
                        </p>
                        <p class="text-sm">Địa chỉ:
                            <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.diaChi }}&nbsp;</b>
                        </p>
                        <p class="text-sm">GPS Long:
                            <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.gpsLong }}&nbsp;</b>
                        </p>
                        <p class="text-sm">GPS Lat:
                            <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.gpsLat }}&nbsp;</b>
                        </p>
                    </div>
                    <div class="col-6 col-md-12 col-lg-6 order-1 order-md-2">
                        <p class="text-sm">Số điện thoại:
                            <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.sdt }}&nbsp;</b>
                        </p>
                        <p class="text-sm">Website:
                            <b class="d-block">&nbsp;&nbsp;&nbsp;<a :href="modelRec.web" target="_blank">{{
                                modelRec.web }}</a>&nbsp;</b>
                        </p>
                        <p class="text-sm">Hiển thị trên cổng:
                            <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.enabled ? "Có" : "Không"
                                }}&nbsp;</b>
                        </p>
                        <p class="text-sm">Ghi chú:
                            <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ghiChu }}&nbsp;</b>
                        </p>
                    </div>
                    <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                        <p class="text-sm">Nhà xe:
                            <span
                                style="border: 1px solid rgba(0, 0, 0, .125); border-radius: 0.25rem; padding: 1em;"
                                class="d-block" id="nhaXe_Detail"></span>
                        </p>
                    </div>
                    <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                        <p class="text-sm">Tuyến đường:
                            <span
                                style="border: 1px solid rgba(0, 0, 0, .125); border-radius: 0.25rem; padding: 1em;"
                                class="d-block" id="tuyenDuong_Detail"></span>
                        </p>
                    </div>
                </div>
            </TheDetailFrameModal>
    <TheConfirmDialogModal :title="csList_MapModel.title"
        :confirmLabelButton="csList_MapModel.confirmLabelButton" :onClose="csList_MapModel.onClose"
        :onSubmit="csList_MapModel.onSubmit" :modalContent=csList_MapModel.modalContent
        :isReConfirm=csList_MapModel.isReConfirm :reConfirmMes=csList_MapModel.reConfirmMes
        v-model:showModalFlag="isShowModal.confirmDialogModal"></TheConfirmDialogModal>

            <TheCheckboxConfirmDialogModal :title="csListEnabled_MapModel.title"
                :confirmLabelButton="csListEnabled_MapModel.confirmLabelButton"
                :onClose="csListEnabled_MapModel.onClose" :onSubmit="csListEnabled_MapModel.onSubmit"
                :modalContent=csListEnabled_MapModel.modalContent :key="tempKey"
                :submitArgs="csListEnabled_MapModel.submitArgs" v-model="checkEnable_Memo"
                v-model:showModalFlag="isShowModal.checkBoxConfirmModal">
            </TheCheckboxConfirmDialogModal>

</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import objectDefaultValue from '@/config/object.env'
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';
import TheImageListPicker from '@/components/shareComponents/TheImageListPicker.vue'

import TheSwapButton from '@/components/shareComponents/table/button/TheSwapButton.vue'
import TheOpenMapButton from '@/components/shareComponents/table/button/TheOpenMapButton.vue'
import TheCreateButton from '@/components/shareComponents/table/button/TheCreateButton.vue'
import TheButtonInDropdown from '@/components/shareComponents/table/button/TheButtonInDropdown.vue'
import TheButtonInTable from '@/components/shareComponents/table/button/TheButtonInTable.vue'

import TheGetLocationButton from '@/components/shareComponents/map/TheGetLocationButton.vue'
import TheSwitchButton from '@/components/shareComponents/TheSwitchButton.vue'

import TheDetailFrameModal from '@/components/shareComponents/modal/TheDetailFrameModal.vue'
import TheCRUDFrameModal from '@/components/shareComponents/modal/TheCRUDFrameModal.vue'
import TheCheckboxConfirmDialogModal from '@/components/shareComponents/modal/TheCheckboxConfirmDialogModal.vue'
import TheConfirmDialogModal from '@/components/shareComponents/modal/TheConfirmDialogModal.vue'


import TheSwitchInTable from '@/components/shareComponents/table/switch/TheSwitchInTable.vue'

import { benXeModel } from '@/models/dichvuthietyeu/benXe.model'
import { tableInteractiveModel } from '@/models/general/tableInteractive.model'

export default {
    name: "TheBenXe",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
        TheImageListPicker,
        TheSwapButton,
        TheOpenMapButton,
        TheCreateButton,
        TheGetLocationButton,
        TheButtonInDropdown,
        TheButtonInTable,
        TheDetailFrameModal,
        TheCRUDFrameModal,
        TheCheckboxConfirmDialogModal,
        TheConfirmDialogModal,
        TheSwitchButton,
        TheSwitchInTable

    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],
            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadOnly: null,

            modelRec: benXeModel.newModel(),
            model: benXeModel.newFEModel(),
            errors: benXeModel.errors(),
            modelSearch: benXeModel.newPagingSearchModel(),

            csList_Navigate: tableInteractiveModel.newList_NavigateModel(),
            csList_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            acceptImageType: objectDefaultValue.ACCEPT_TYPE_IMG,
            acceptTypeExcel: objectDefaultValue.ACCEPT_TYPE_EXCEL,

            cEnable_Item: null,
            checkEnable_Memo: false,

            category_ENABLED: objectDefaultValue.ENABLED_SELECTION,
            csListEnabled_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            //Upload Image
            filesUpload: [],
            listFileNameUpload: {
                nameFilesUpload: '',
            },

            isShowModal: {
                CRUDModal: false,
                detailModal: false,
                checkBoxConfirmModal: false,
                confirmDialogModal: false,
                importModal: false,
            },
            loadingSubmit: false,
            tempKey: common.randomString(10),

            currentSearchType: objectDefaultValue.TYPEDATA_LIST.CURRENT_LIST.id,
            navigateCode: objectDefaultValue.NAVIGATECODE_VALUE,
            navigateList: objectDefaultValue.NAVIGATECODE_LIST,
            typeDataList: objectDefaultValue.TYPEDATA_LIST,
            tableButton: objectDefaultValue.TABLEBUTTON,

        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber'],),
        ...mapActions('handleData2', ['handleTypeImport', 'handleChangeType', 'formatData']),
        ...mapActions('benXe', ['getPagingBenXe', 'getDetailBenXe', 'checkExistBenXe', 'createBenXe', 'updateBenXe', 'deleteBenXe', 'restoreBenXe', 'handleListBenXe', 'setEnabledBenXe', 'getMapInfoBenXe']),
        async setup() {
            let header = 'Danh sách Bến xe'
            this.setupHeader({ header })
        },

        async initialize() {
        },
        //#region TableNavigation
        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.modelSearch.sort = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
            await this.navigateCheckBoxAll()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },
        async onSearchKey() {
            this.pageNumber = config.CURRENT_PAGE
            await this.getData()
        },
        async showEnabledConfirmModal() {
            this.csListEnabled_MapModel = {
                title: "XÁC NHẬN",
                confirmLabelButton: "Xác nhận",
                onClose: this.closeConfirmEnabledChange,
                onSubmit: this.updateEnabled,
                submitArgs: [2],
                modalContent: "<label>Bạn có chắc chắn muốn thay đổi hiển thị trên cổng?</label>",
            }
            this.isShowModal.checkBoxConfirmModal = true
        },
        async navigateEnabledChange(id,  value) {
            if (!this.checkEnable_Memo) {
                this.cEnable_Item = {
                    id: id,
                    enabled: value
                }
                await this.showEnabledConfirmModal()
            }
            else {
                this.cEnable_Item = {
                    id: id,
                    enabled: value
                }
                this.updateEnabled()
            }
        },
        async updateEnabled() {
            let model = {
                benXeId: this.cEnable_Item.id,
                enabled: this.cEnable_Item.enabled
            }
            await this.setEnabledBenXe({ model: model }).then(async resp => {
                if (resp) {
                    this.isShowModal.checkBoxConfirmModal = false
                }
                else {
                    const itemIndex = this.items.findIndex(item => item.benXeId === this.cEnable_Item.id);
                    if (itemIndex !== -1) {
                        this.items[itemIndex].enabled = !this.items[itemIndex].enabled;

                    } else {
                        await this.getData()
                    }
                }

            });
        },
        async closeConfirmEnabledChange() {
            const itemIndex = this.items.findIndex(item => item.benXeId === this.cEnable_Item.benXeId);
            if (itemIndex !== -1) {
                this.items[itemIndex].enabled = !this.items[itemIndex].enabled;
            } else {
                await this.getData()
            }
            this.isShowModal.checkBoxConfirmModal = false
        },


        async navigateCheckBoxAll() {
            if (this.items.length != 0 && this.items.length == this.csList_Navigate.csList.length) {
                document.getElementById("checkboxAll").checked = true;
            }
            else {
                document.getElementById("checkboxAll").checked = false;
            }
        },
        async selectRow(id) {
            if (this.csList_Navigate.csList.includes(id)) {
                this.csList_Navigate.csList.splice(this.csList_Navigate.csList.indexOf(id), 1)
            }
            else {
                this.csList_Navigate.csList.push(id)
            }
            await this.navigateCheckBoxAll()
        },
        async unSelectAllRows() {
            this.csList_Navigate.csList = []
            document.getElementById("checkboxAll").checked = false
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.csList_Navigate.csList = this.items.map((item) => {
                    return item.benXeId
                })
            }
            else {
                this.csList_Navigate.csList = []
            }
        },
        async standardizationFilter() {
            this.modelSearch.pageNumber = this.pageNumber
            this.modelSearch.pageSize = this.pageSize
            this.modelSearch.enabled = await this.handleChangeType({ input: this.modelSearch.enabled, typeChange: objectDefaultValue.changeTypeData.STRING_TO_BOOLEAN })
        },
        async getData() {
            this.isBusy = true
            this.csList_Navigate.csList = []
            await this.standardizationFilter()
            await this.unSelectAllRows()
            await this.getPagingBenXe({ params: this.modelSearch, type: this.currentSearchType }).then(res => {
                // List data
                this.items = res.data
                this.totalRow = res.totalRow
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },
        //#endregion TableNavigation

        //#region CRUD
        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            this.styleButton = this.$t('style.styleButton' + code)
            this.styleTitle = this.$t('style.styleTitle' + code)
            this.errors = benXeModel.errors()

            this.filesUpload = []
            this.listFileNameUpload.filesUpload = []


            this.loadingSubmit = false

            if (this.code == this.navigateCode.UPDATE || this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) {
                let params = {
                    benXeId: item.benXeId
                }
                await this.getDetailBenXe({ params }).then(async resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = benXeModel.newModel()
                        this.modelRec = resp
                        this.model = benXeModel.parseModeltoFEModel(this.modelRec)
                        //this.triggerDetail()
                        let fHinhAnh = [{
                            fileId: this.modelRec.hinhAnh,
                            fileName: this.modelRec.tenFileHinhAnh,
                            downloadLink: this.modelRec.linkHinhAnh,
                        }]
                        this.filesUpload = this.modelRec.hinhAnh ? JSON.parse(JSON.stringify(fHinhAnh)) : [];
                        this.listFileNameUpload.nameFilesUpload = this.modelRec.tenFileHinhAnh
                    }
                });
                this.isReadOnly = (this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) ? true : false
                this.tempKey = common.randomString(10)
                this.isShowModal.CRUDModal = true
            }
            else if (this.code == this.navigateCode.DETAIL) {
                let params = {
                    benXeId: item.benXeId
                }
                await this.getDetailBenXe({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = benXeModel.newModel()
                        this.modelRec = resp

                        if (this.modelRec.nhaXe) {
                            let contentDiv = document.getElementById('nhaXe_Detail');
                            contentDiv.innerHTML = this.modelRec.nhaXe;
                        }
                        else {
                            let contentDiv = document.getElementById('nhaXe_Detail');
                            contentDiv.innerHTML = '';
                        }

                        if (this.modelRec.tuyenDuong) {
                            let contentDiv = document.getElementById('tuyenDuong_Detail');
                            contentDiv.innerHTML = this.modelRec.tuyenDuong;
                        }
                        else {
                            let contentDiv = document.getElementById('tuyenDuong_Detail');
                            contentDiv.innerHTML = '';
                        }
                    }
                });
                this.tempKey = common.randomString(10)
                this.isShowModal.detailModal = true
            }
            else {
                this.model = benXeModel.newFEModel()
                this.isReadOnly = false
                // show popup
                this.tempKey = common.randomString(10)
                this.isShowModal.CRUDModal = true
            }
        },
        async checkExistName(name) {
            let params = {
                ten: name
            }
            let res = await this.checkExistBenXe({ params: params })
            return res.data
        },
        async validate(model) {
            let isvalid = true
            this.errors = benXeModel.errors()
            if (!await this.validateRequired(model.ten)) {
                this.errors.ten = "Nhập tên"
                isvalid = false
            }
            else if (this.code == this.navigateCode.UPDATE && this.modelRec.ten != model.ten) {
                if (await this.checkExistName(model.ten)) {
                    this.errors.ten = "Tên này đã tồn tại trên hệ thống"
                    isvalid = false
                }
            }
            else if (this.code == this.navigateCode.CREATE) {
                if (await this.checkExistName(model.ten)) {
                    this.errors.ten = "Tên này đã tồn tại trên hệ thống"
                    isvalid = false
                }
            }
            if (!await this.validateRequired(model.stt)) {
                this.errors.stt = "Nhập số thứ tự"
                isvalid = false
            }
            else if (!await this.validateNumber(model.stt)) {
                this.errors.stt = "Số thứ tự phải là kiểu số"
                isvalid = false
            }
            return isvalid
        },
        async modifySendModel(FEmodel) {
            let sendModel = benXeModel.newModel()
            if (this.code == this.navigateCode.DELETE
                || this.code == this.navigateCode.RESTORE
                || this.code == this.navigateCode.DELETE_TEMP) sendModel.benXeId = FEmodel.benXeId
            else {
                if (this.code == this.navigateCode.UPDATE) sendModel.benXeId = FEmodel.benXeId
                sendModel.ten = FEmodel.ten
                sendModel.diaChi = FEmodel.diaChi
                sendModel.gpsLong = FEmodel.gpsLong
                sendModel.gpsLat = FEmodel.gpsLat
                sendModel.sdt = FEmodel.sdt
                sendModel.tuyenDuong = FEmodel.tuyenDuong
                sendModel.nhaXe = FEmodel.nhaXe
                sendModel.web = FEmodel.web
                sendModel.ghiChu = FEmodel.ghiChu
                sendModel.stt = FEmodel.stt
                sendModel.enabled = FEmodel.enabled ? FEmodel.enabled : false
                let formatToSendHinhAnh = {
                    typeSend: this.code,
                    files: this.filesUpload,
                    nameOldFile: this.listFileNameUpload.nameFilesUpload,
                }
                await this.formatData({ input: formatToSendHinhAnh, typeFormat: 'aFileToSend' }).then(resp => {
                    if (resp) {
                        sendModel.fHinhAnh = resp.file
                        sendModel.xoaHinhAnh = resp.isDeleted
                    }
                })



            }
            return sendModel
        },
        async handleSubmit() {
            if (this.code === this.navigateCode.DELETE) {
                this.csList_MapModel = {
                    title: this.$t('labels.confirmDelete'),
                    confirmLabelButton: this.$t('buttons.confirm'),
                    onClose: null,
                    onSubmit: this.onSubmit,
                    modalContent: "<span>Bạn có chắc chắn muốn <b> xóa vĩnh viễn </b>dữ liệu đã chọn? </span><br/><span><b>Dữ liệu sau khi xóa sẽ không thể khôi phục lại</b></span>",
                }
                this.isShowModal.confirmDialogModal = true
            }
            else {
                await this.onSubmit()
            }
        },
        async onSubmit() {
            this.loadingSubmit = true
            let code = this.code
            let sendModel = await this.modifySendModel(this.model)
            let res = false
            switch (code) {
                case this.navigateCode.CREATE:
                    if (await this.validate(sendModel)) {
                        res = await this.createBenXe({ model: sendModel })
                    }
                    break
                case this.navigateCode.UPDATE:
                    if (await this.validate(sendModel)) {
                        res = await this.updateBenXe({ model: sendModel })
                    }
                    break
                case this.navigateCode.DELETE_TEMP:
                    res = await this.deleteBenXe({ model: sendModel, type: this.currentSearchType })
                    break
                case this.navigateCode.DELETE:
                    res = await this.deleteBenXe({ model: sendModel, type: this.currentSearchType })
                    if (res) this.isShowModal.confirmDialogModal = false
                    break
                case this.navigateCode.RESTORE:
                    res = await this.restoreBenXe({ model: sendModel })
                    break
                default:
            }
            if (res) {
                this.isShowModal.CRUDModal = false
                await this.getData()
            }

            this.loadingSubmit = false
        },
        //#endregion CRUD
        //#region ListNavigation
        async confirmList(code) {
            if (this.csList_Navigate.csList.length == 0) {
                this.warning(this.$t('labels.selectItem'))
            }
            else {
                this.csList_Navigate.csList_Code = code
                let foundItem = this.navigateList.find(item => item.code === code);
                this.csList_Navigate.csList_Title = foundItem ? foundItem.title : ""

                let tempReConfirmMes = code == this.navigateCode.DELETE ?"<span>Bạn có chắc chắn muốn <b> xóa vĩnh viễn </b>những dữ liệu đã chọn? </span><br/><span><b>Dữ liệu sau khi xóa sẽ không thể khôi phục lại</b></span>" : null
                this.csList_MapModel = {
                    isReConfirm: code == this.navigateCode.DELETE ? true : false,
                    reConfirmMes: tempReConfirmMes,
                    title: this.csList_Navigate.csList_Title,
                    confirmLabelButton: this.csList_Navigate.csList_Title,
                    onClose: null,
                    onSubmit: this.onSubmitList,
                    modalContent: "Bạn có chắc chắn <b>" + this.csList_Navigate.csList_Title + "</b> các dữ liệu đã chọn?",
                }
                this.isShowModal.confirmDialogModal = true
            }
        },

        async onSubmitList() {
            let code = this.csList_Navigate.csList_Code
            let modelSend = {
                model: {
                    listId: this.csList_Navigate.csList.toString()
                },
                type: code
            }
            if (code == this.navigateCode.OFF_ENABLED) {
                modelSend.model.enabled = false
            }
            if (code == this.navigateCode.ON_ENABLED) {
                modelSend.model.enabled = true
            }
            let res = null
            if (code == objectDefaultValue.NAVIGATECODE_VALUE.DELETE) {
                res = await this.handleListBenXe(modelSend)
            }
            else {
                res = await this.handleListBenXe(modelSend)
            }

            if (res) {
                await this.getData()
                await this.navigateCheckBoxAll()
                this.isShowModal.confirmDialogModal = false
            }
        },
    //#endregion ListNavigation
    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()
    }
}
</script>
<style>
</style>
